import { ApplicationConfig, importProvidersFrom, ErrorHandler } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { provideRouter, withInMemoryScrolling, withRouterConfig } from "@angular/router";
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { environment } from "src/environments/environment";
import { routes } from "./app.routes";
import { SubscriptionModule } from "./subscription/subscription.module";

// for HttpClient import:
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideLoadingBarInterceptor } from '@ngx-loading-bar/http-client';
import { authInterceptor, baseUrlInterceptor } from './core/http';

// for Router import:
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';
import { LOADING_BAR_CONFIG } from '@ngx-loading-bar/core';
import { FILE_UPLOAD_SERVICE_TOKEN } from "./core/file-upload.interface";
import { FileUploadService } from "./core/services/file-upload.service";
import { ChunkErrorHandlerService } from "./core/services/chunk-error-handler.service";
import { PLANNER_PLAN_LOADER } from "./features/planner/planner-plan-loader.token";
import { PlannerService } from "./features/planner/planner.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, authInterceptor]),
      withInterceptorsFromDi(),
    ),
    provideLoadingBarInterceptor(),
    provideLoadingBarRouter(),
    importProvidersFrom(
      ReactiveFormsModule,
      ReactiveFormsModule,
      FormlyModule.forRoot(),
      FormlyBootstrapModule,
      SubscriptionModule.forRoot({
          auth: {
              disableSigninWithEmail: false,
              providers: [{ id: "google", label: "Google" }],
              captcha: {
                  type: environment.CAPTCHA_TYPE as "turnstile" | "none",
                  turnstileSiteKey: environment.TURNSTILE_SITE_KEY,
              },
          },
          supabase: {
              key: environment.SUPABASE_KEY,
              url: environment.SUPABASE_URL,
          },
          tables: {
              userProfile: "user_profile",
              userSettings: "user_settings",
          },
      }),
    ),
    {
      provide: FILE_UPLOAD_SERVICE_TOKEN,
      useClass: FileUploadService,
    },
    {
      provide: ErrorHandler,
      useClass: ChunkErrorHandlerService,
    },
    {
      provide: LOADING_BAR_CONFIG,
      useValue: { latencyThreshold: 100 },
    },
    {
      provide: PLANNER_PLAN_LOADER,
      useExisting: PlannerService,
    },
  ],
};
